import React from 'react';
import { ArrowLeftIcon, FileTextIcon } from 'lucide-react';
export function TermsAndConditions() {
  return <main className="min-h-screen w-full bg-[#fcfbf7] px-5 py-10 text-[#344833] sm:px-8 sm:py-16" data-id="element-509">
      <div className="mx-auto max-w-3xl" data-id="element-510">
        <a href="/" className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.12em] text-[#597050] transition-colors hover:text-[#30452e]" data-id="element-511">
          <ArrowLeftIcon size={16} data-id="element-512" />
          VOLVER A CÓDIGO FITNESS™
        </a>

        <article className="mt-12 border border-[#e1e4da] bg-[#fffefa] p-7 shadow-[0_12px_35px_rgba(61,75,53,0.07)] sm:p-12" data-id="element-513">
          <div className="flex items-center gap-3 text-[#66805c]" data-id="element-514">
            <FileTextIcon size={20} strokeWidth={1.5} aria-hidden="true" data-id="element-515" />
            <p className="text-xs font-bold tracking-[0.2em]" data-id="element-516">
              INFORMACIÓN LEGAL
            </p>
          </div>
          <h1 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-517">
            Términos y Condiciones
          </h1>

          <div className="mt-10 space-y-9 leading-8 text-[#5d6a59]" data-id="element-518">
            <section data-id="element-519">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-520">
                Condiciones de compra
              </h2>
              <p className="mt-3" data-id="element-521">
                Al realizar una compra de Código Fitness™ confirmas que has
                revisado la descripción del producto y aceptas estos Términos y
                Condiciones, la Política de Privacidad y la Política de
                Reembolsos. La compra da acceso a contenido digital, conforme a
                la oferta presentada al momento del pago.
              </p>
            </section>

            <section data-id="element-522">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-523">
                Acceso inmediato al producto digital
              </h2>
              <p className="mt-3" data-id="element-524">
                Una vez confirmado el pago, el contenido digital se entrega o se
                habilita de forma inmediata mediante las instrucciones o el
                acceso indicado en la compra. Es responsabilidad del usuario
                proporcionar datos correctos y conservar la información de
                acceso recibida.
              </p>
            </section>

            <section data-id="element-525">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-526">
                Licencia de uso
              </h2>
              <p className="mt-3" data-id="element-527">
                Al adquirir Código Fitness™ recibes una licencia limitada,
                personal, no exclusiva, no transferible y revocable para
                consultar y utilizar el contenido con fines personales. La
                compra no implica la transferencia de derechos de propiedad
                intelectual sobre las guías, recetas, textos, diseños o
                materiales incluidos.
              </p>
            </section>

            <section data-id="element-528">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-529">
                Propiedad intelectual y restricciones
              </h2>
              <p className="mt-3" data-id="element-530">
                Todos los contenidos de Código Fitness™ están protegidos por
                las normas aplicables de propiedad intelectual. No está
                permitido copiar, reproducir, modificar, distribuir, publicar,
                vender, revender, compartir, sublicenciar o explotar los
                materiales, total o parcialmente, sin autorización previa y
                expresa.
              </p>
              <p className="mt-3" data-id="element-531">
                Tampoco está permitido compartir enlaces de descarga, archivos,
                accesos o credenciales con terceros. El uso no autorizado puede
                resultar en la suspensión del acceso, sin perjuicio de las
                acciones que correspondan.
              </p>
            </section>

            <section data-id="element-532">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-533">
                Responsabilidad del usuario
              </h2>
              <p className="mt-3" data-id="element-534">
                El usuario es responsable de utilizar el contenido de manera
                personal, razonable y conforme a estos términos. También es
                responsable de evaluar si las recomendaciones educativas se
                ajustan a su situación particular y de consultar a un
                profesional de la salud cuando sea necesario.
              </p>
            </section>

            <section data-id="element-535">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-536">
                Limitación de responsabilidad
              </h2>
              <p className="mt-3" data-id="element-537">
                Código Fitness™ se ofrece con fines educativos e informativos.
                No garantiza resultados específicos, ya que estos dependen de
                múltiples factores personales. En la máxima medida permitida por
                la ley aplicable, Código Fitness™ no será responsable por
                decisiones, usos o resultados derivados de la aplicación del
                contenido.
              </p>
            </section>

            <section data-id="element-538">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-539">
                Condiciones generales del servicio
              </h2>
              <p className="mt-3" data-id="element-540">
                Podemos actualizar estos términos cuando sea necesario para
                reflejar cambios en el servicio, la operación o la normativa
                aplicable. El uso continuado del contenido después de la
                publicación de una actualización supone la aceptación de los
                términos vigentes. Si surge una consulta sobre tu compra,
                utiliza el canal de soporte indicado en la confirmación de pago.
              </p>
            </section>
          </div>
        </article>

        <p className="mt-8 text-center text-xs text-[#7a8574]" data-id="element-541">
          © 2026 Código Fitness™. Todos los derechos reservados.
        </p>
      </div>
    </main>;
}